import {
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,
  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILURE,
  FETCH_ORDER_BY_ID_REQUEST,
  FETCH_ORDER_BY_ID_SUCCESS,
  FETCH_ORDER_BY_ID_FAILURE,
  ACCEPT_SHORTFALL_REQUEST,
  ACCEPT_SHORTFALL_SUCCESS,
  ACCEPT_SHORTFALL_FAILURE,
} from './actions';
import { PO_PENDING_APPROVAL, CLEAR_PO_PENDING_APPROVAL } from '../../redux/constants/actionTypes';

const initialState = {
  orders: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 0,
  },
  loading: false,
  error: null,
  currentOrder: null,
  // Set when a newly created PO is routed to approval instead of PDF
  pendingApprovalPO: null,
  // Separate from `loading` so accepting a shortfall doesn't flip the main
  // orders table into a loading state.
  shortfallLoading: false,
};

const purchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDERS_REQUEST:
    case CREATE_ORDER_REQUEST:
    case UPDATE_ORDER_REQUEST:
    case FETCH_ORDER_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.orders || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        // For PDF download, we don't need to add to orders array since we refresh the list
      };

    case UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: state.orders.map((order) =>
          order.id === action.payload.id ? action.payload : order
        ),
        error: null,
      };

    case FETCH_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        currentOrder: action.payload,
        error: null,
      };

    case PO_PENDING_APPROVAL:
      return { ...state, loading: false, pendingApprovalPO: action.payload };

    case CLEAR_PO_PENDING_APPROVAL:
      return { ...state, pendingApprovalPO: null };

    case ACCEPT_SHORTFALL_REQUEST:
      return { ...state, shortfallLoading: true };

    case ACCEPT_SHORTFALL_SUCCESS:
      return { ...state, shortfallLoading: false };

    case ACCEPT_SHORTFALL_FAILURE:
      return { ...state, shortfallLoading: false };

    case FETCH_ORDERS_FAILURE:
    case CREATE_ORDER_FAILURE:
    case UPDATE_ORDER_FAILURE:
    case FETCH_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default purchaseOrderReducer;
